
export default Object.freeze({
    LANG_WORDS: [
        {
            key: '走行',
            ja: '走行',
            en: 'DRIVE',
            en_html: '<span style="font-size:0.5rem;">%%</span>',
        },
        {
            key: '宿泊',
            ja: '宿泊',
            en: 'Accomodation',
            en_html: '<span style="font-size:0.5rem;">%%</span>',
        },
        {
            key: '施設',
            ja: '施設',
            en: 'Facility',
            en_html: '<span style="font-size:0.5rem;">%%</span>',
        },
        {
            key: '走行予約',
            ja: '走行予約',
            en: 'DRIVE',
            en_html: '',
        },
        {
            key: '宿泊予約',
            ja: '宿泊予約',
            en: 'Accomodation',
            en_html: '',
        },
        {
            key: '施設予約',
            ja: '施設予約',
            en: 'Facility',
            en_html: '',
        },
        {
            key: '施設予約をする',
            ja: '準備中',
            en: '',
            en_html: '',
        },
        {
            key: '編集',
            ja: '編集',
            en: 'EDIT',
            en_html: '',
        },
        {
            key: '予約済',
            ja: '予約済',
            en: 'reserved',
            en_html: '',
        },
        {
            key: '日付',
            ja: '日付',
            en: 'DATE',
            en_html: '',
        },
        {
            key: '会員証を表示',
            ja: '会員証を表示',
            en: 'Show membership',
            en_html: '',
        },
        {
            key: '閉じる',
            ja: '閉じる',
            en: 'CLOSE',
            en_html: '',
        },
        {
            key: '走行を予約する',
            ja: '走行・宿泊それぞれのカレンダーをご確認ください',
            en: '',
            en_html: '',
        },
        {
            key: '以下のご予約を承っております',
            ja: '以下のご予約を承っております',
            en: 'accept this reservation',
        },

        {
            key: '走行人数',
            ja: '走行人数',
            en: 'Number of People',
            en_html: '',
        },
        {
            key: 'select人',
            ja: '人',
            en: 'persons',
            en_html: '',
        },
        {
            key: '検索',
            ja: '検索',
            en: 'SEARCH',
            en_html: '',
        },
        {
            key: '走行者',
            ja: '走行者',
            en: 'Driver',
            en_html: '',
        },
        {
            key: 'プログラム',
            ja: 'プログラム',
            en: 'Program',
            en_html: '',
        },
        {
            key: 'お友達検索',
            ja: 'お友達検索',
            en: 'Search Friend',
            en_html: '',
        },
        {
            key: '料金',
            ja: '料金',
            en: 'Price',
            en_html: '',
        },
        {
            key: 'ホーム',
            ja: 'ホーム',
            en: 'Home',
            en_html: '',
        },
        {
            key: '予約',
            ja: '予約',
            en: 'Reservation',
            en_html: '',
        },
        {
            key: 'お知らせ',
            ja: 'お知らせ',
            en: 'Information',
            en_html: '',
        },
        {
            key: 'カレンダー',
            ja: 'カレンダー',
            en: 'Calendar',
            en_html: '',
        },
        {
            key: 'イベント',
            ja: 'イベント',
            en: 'Event',
            en_html: '',
        },
        {
            key: '会員証',
            ja: '会員証',
            en: 'Account',
            en_html: '',
        },
        {
            key: '予約枠を選択してください。',
            ja: '予約枠を選択してください。',
            en: 'Please select',
            en_html: '',
        },
        {
            key: '予約を進める',
            ja: '予約を進める',
            en: 'Make Reservation',
            en_html: '',
        },
        {
            key: '予約内容を確認する',
            ja: '予約内容を確認する',
            en: 'Confirm Reservation',
            en_html: '',
        },
        {
            key: '予約する',
            ja: '予約する',
            en: 'Make Reservation',
            en_html: '',
        },
        {
            key: '走行を予約する',
            ja: '走行を予約する',
            en: 'Reserve a drive',
            en_html: '',
        },
        {
            key: '宿泊予約をする',
            ja: '走行・宿泊それぞれのカレンダーをご確認ください',
            // en: 'For the hotel reservation, please contact us by phone or e-mail for the time being.',
            en: '',
            en_html: '',
        },
        {
            key: '施設の予約をする',
            ja: '当面の間、施設のご予約は電話にて承ります。',
            en: 'For the facility reservation e.g. restaurant etc.. please contact us by phone or e-mail for the time being.',
            en_html: '',
        },
        {
            key: '予約する',
            ja: '予約する',
            en: 'Make Reservation',
            en_html: '',
        },
        {
            key: '予約確認',
            ja: '予約確認',
            en: 'Check Reservation',
            en_html: '',
        },
        {
            key: '走行履歴',
            ja: '走行履歴',
            en: 'Usage History',
            en_html: '',
        },
        {
            key: '宿泊履歴',
            ja: '宿泊履歴',
            en: 'Usage History',
            en_html: '',
        },
        {
            key: '利用履歴',
            ja: '利用履歴',
            en: 'Usage History',
            en_html: '',
        },
        {
            key: '選択して下さい',
            ja: '選択して下さい',
            en: 'Please select',
            en_html: '',
        },
        {
            key: 'ご希望の走行枠を選択してください。',
            ja: 'ご希望の走行枠を選択してください。',
            en: 'Please Select Your Preferred Session(s).',
            en_html: '',
        },
        {
            key: '走行予約枠が設定されていません。',
            ja: '走行予約枠が設定されていません。',
            en: 'No reservation slots have been set.',
            en_html: '',
        },
        {
            key: '予約内容を入力してください。',
            ja: '予約内容を入力してください。',
            en: 'Please enter your reservation details.',
            en_html: '',
        },
        {
            key: '検索ワード',
            ja: '検索ワード',
            en: 'Search words',
            en_html: '',
        },
        {
            key: 'は必須項目です。',
            ja: 'は必須項目です。',
            en: ' is required.',
            en_html: '',
        },
        {
            key: '入力msg_Pre',
            ja: '',
            en: 'Please Enter ',
            en_html: '',
        },
        {
            key: '入力msg_Post',
            ja: 'を入力して下さい。',
            en: ' ',
            en_html: '',
        },
        {
            key: '走行人数を入力してください。',
            ja: '走行人数を入力してください。',
            en: 'Please enter the number of people.',
            en_html: '',
        },
        {
            key: '走行者を選択してください。',
            ja: '走行者を選択してください。',
            en: 'Please select driver.',
            en_html: '',
        },
        {
            key: '本人',
            ja: '本人',
            en: 'myself',
            en_html: '',
        },
        {
            key: 'フレンド',
            ja: 'フレンドメンバー',
            en: 'friend',
            en_html: '',
        },
        {
            key: 'ゲスト',
            ja: 'ゲスト',
            en: 'guest',
            en_html: '',
        },
        {
            key: 'タイプ',
            ja: 'タイプ',
            en: 'Type',
            en_html: '',
        },
        {
            key: '車両タイプ',
            ja: '車両タイプ',
            en: 'Car type',
            en_html: '',
        },
        {
            key: '車種',
            ja: '車種',
            en: 'Car model',
            en_html: '',
        },
        {
            key: '画像一覧',
            ja: '画像一覧',
            en: 'Image list',
            en_html: '',
        },
        {
            key: '画像',
            ja: '画像',
            en: 'Image',
            en_html: '',
        },
        {
            key: '運輸支局',
            ja: '運輸支局',
            en: 'Land Transport Bureau Branch Office',
            en_html: '',
        },

        {
            key: '分類番号',
            ja: '分類番号',
            en: 'Class Number',
            en_html: '',
        },
        {
            key: 'かな文字',
            ja: 'かな文字',
            en: 'Kana',
            en_html: '',
        },
        {
            key: 'ナンバー',
            ja: 'ナンバー',
            en: 'Number',
            en_html: '',
        },
        {
            key: '地名',
            ja: '地名',
            en: 'Area',
            en_html: '',
        },
        {
            key: '3桁の数字',
            ja: '3桁の数字',
            en: 'Triple digits',
            en_html: '',
        },
        {
            key: 'かな',
            ja: 'かな',
            en: 'Kana',
            en_html: '',
        },
        {
            key: '４桁の数字',
            ja: '４桁の数字',
            en: 'four digit number',
            en_html: '',
        },


        {
            key: 'メーカー',
            ja: 'メーカー',
            en: 'Auto Manufacturer',
            en_html: '',
        },
        {
            key: '年式',
            ja: '年式',
            en: 'Model Year',
            en_html: '',
        },
        {
            key: 'モデル',
            ja: 'モデル',
            en: 'Model',
            en_html: '',
        },
        {
            key: '備考',
            ja: '備考',
            en: 'Remarks',
            en_html: '',
        },
        {
            key: '保管',
            ja: '保管',
            en: 'Strage',
            en_html: '',
        },
        {
            key: 'ナンバー情報',
            ja: 'ナンバー情報',
            en: 'License Plate',
            en_html: '',
        },
        {
            key: '車両詳細情報',
            ja: '車両詳細情報',
            en: 'Detail',
            en_html: '',
        },
        {
            key: '走行・来場にお使いになる車両をすべてご登録ください。',
            ja: '走行・来場にお使いになる車両をすべてご登録ください。',
            en: 'Add Vehicle',
            en_html: '',
        },
        {
            key: '車両を追加登録する。',
            ja: '車両を追加登録する。',
            en: 'Add Vehicle',
            en_html: '',
        },
        {
            key: '登録できる車両数は',
            ja: '登録できる車両数は',
            en: 'MAX',
            en_html: '',
        },
        {
            key: '台までです。',
            ja: '台までです。',
            en: ' Car',
            en_html: '',
        },
        {
            key: '車両を追加してください。',
            ja: '車両を追加してください。',
            en: 'please add Vehicle.',
            en_html: '',
        },
        {
            key: 'の車両情報を削除する',
            ja: 'の車両情報を削除する',
            en: ' Delete',
            en_html: '',
        },
        {
            key: 'メンバーズガイド',
            ja: 'メンバーズガイド',
            en: 'MEMBER\'S GUIDE',
            en_html: '',
        },
        {
            key: 'ファシリティガイド',
            ja: '施設利用ガイド',
            en: 'FACILITY GUIDE',
            en_html: '',
        },
        {
            key: 'フロアマップ',
            ja: 'フロアマップ',
            en: 'Floor map',
            en_html: '',
        },
        {
            key: 'アクセス',
            ja: 'アクセス',
            en: 'Access',
            en_html: '',
        },
        {
            key: 'お問い合わせ',
            ja: 'お問い合わせ',
            en: 'Inquiry',
            en_html: '',
        },
        {
            key: 'プライバシーポリシー',
            ja: 'プライバシーポリシー',
            en: 'Privacy Policy',
            en_html: '',
        },
        {
            key: '会員情報',
            ja: '会員情報',
            en: 'Edit Member Info',
            en_html: '',
        },
        {
            key: '車両情報',
            ja: '車両情報',
            en: 'Vehicle Info',
            en_html: '',
        },
        {
            key: 'ゲスト情報',
            ja: 'ゲスト情報',
            en: 'Guest Info',
            en_html: '',
        },
        {
            key: 'フレンド情報',
            ja: 'フレンド情報',
            en: 'Friend',
            en_html: '',
        },
        {
            key: 'チェックイン情報',
            ja: 'チェックイン情報',
            en: 'Checkin Info',
            en_html: '',
        },
        {
            key: '姓',
            ja: '姓',
            en: 'last name',
            en_html: '',
        },
        {
            key: 'ミドルネーム',
            ja: 'ミドルネーム',
            en: 'middle name',
            en_html: '',
        },
        {
            key: '名',
            ja: '名',
            en: 'first name',
            en_html: '',
        },
        {
            key: '電話番号',
            ja: '電話番号',
            en: 'tel',
            en_html: '',
        },
        {
            key: '携帯',
            ja: '携帯',
            en: 'mobile',
            en_html: '',
        },
        {
            key: '〒',
            ja: '〒',
            en: 'postal cd',
            en_html: '',
        },
        {
            key: '都道府県',
            ja: '都道府県',
            en: 'Pref',
            en_html: '',
        },
        {
            key: '市区町村',
            ja: '市区町村',
            en: 'City',
            en_html: '',
        },
        {
            key: '町域番地',
            ja: '町域番地',
            en: 'Address Line 1',
            en_html: '',
        },
        {
            key: '建物名・号室',
            ja: '建物名・号室',
            en: 'Address Line 2',
            en_html: '',
        },
        {
            key: '生年月日',
            ja: '生年月日',
            en: 'birth day',
            en_html: '',
        },
        {
            key: '性別',
            ja: '性別',
            en: 'Sex',
            en_html: '',
        },
        {
            key: 'RH',
            ja: 'RH',
            en: 'RH',
            en_html: '',
        },
        {
            key: '血液型',
            ja: '血液型',
            en: 'blood type',
            en_html: '',
        },
        {
            key: '予約詳細',
            ja: '予約詳細',
            en: 'DETAIL',
            en_html: '',
        },
        {
            key: '詳細',
            ja: '詳細',
            en: 'DETAIL',
            en_html: '',
        },
        {
            key: '登録',
            ja: '登録',
            en: 'UPDATE',
            en_html: '',
        },
        {
            key: 'ゲスト情報を登録してください。',
            ja: 'ゲスト情報を登録してください。',
            en: 'Add Guest',
            en_html: '',
        },
        {
            key: 'ゲストを追加登録する。',
            ja: 'ゲストを追加登録する。',
            en: 'Add Guest',
            en_html: '',
        },
        {
            key: '登録できるゲスト人数は',
            ja: '登録できるゲスト人数は',
            en: 'MAX',
            en_html: '',
        },
        {
            key: '人までです。',
            ja: '人までです。',
            en: ' persons',
            en_html: '',
        },
        {
            key: 'お問い合わせH',
            ja: 'お問い合わせ',
            en: '',
            en_html: '',
        },
        {
            key: '削除',
            ja: '削除',
            en: 'Delete',
            en_html: '',
        },
        {
            key: '件名',
            ja: 'お問い合わせ内容',
            en: 'Title',
            en_html: '',
        },
        {
            key: 'お名前',
            ja: 'お名前',
            en: 'Name',
            en_html: '',
        },
        {
            key: '返信先',
            ja: '返信先',
            en: 'Where to Reply',
            en_html: '',
        },
        {
            key: '内容',
            ja: '内容',
            en: 'Content',
            en_html: '',
        },
        {
            key: 'お問い合わせ項目を全て入力してください。',
            ja: 'すべての項目をご入力ください。',
            en: 'Please enter all inquiry items.',
            en_html: '',
        },
        {
            key: '送信する',
            ja: '送信',
            en: 'SEND',
            en_html: '',
        },
        {
            key: 'access_info_001',
            ja: '「富浦インターチェンジ」出口からクラブまでは、下記のルートでお越しください。',
            en: 'Please take the following route from the Tomiura Interchange exit to the club. ',
            en_html: '',
        },
        {
            key: 'access_info_002',
            ja: '近隣にある幼稚園の前を通ることなく、ご来場いただけます。',
            en: 'You will not have to pass by a kindergarten in the neighborhood. ',
            en_html: '',
        },
        {
            key: 'access_info_003',
            ja: '事故の防止、近隣住民との良好な関係維持の観点から、ご理解とご協力をお願いいたします。',
            en: 'We ask for your understanding and cooperation in terms of preventing accidents and maintaining good relations with the neighborhood.',
            en_html: '',
        },
        {
            key: '正会員',
            ja: '正会員',
            en: 'MEMBER',
            en_html: '',
        },
        {
            key: 'アソシエイト',
            ja: 'アソシエイト',
            en: 'ASSOCIATE',
            en_html: '',
        },
        {
            key: 'メールアドレス(お客様ID)',
            ja: 'メールアドレス',
            en: 'Email Address (Customer ID)',
            en_html: '',
        },
        {
            key: 'メールアドレスを変更する',
            ja: 'メールアドレスを変更する',
            en: 'Change Email Address',
            en_html: '',
        },
        {
            key: 'パスワード',
            ja: 'パスワード',
            en: 'Password',
            en_html: '',
        },
        {
            key: 'パスワードを変更する',
            ja: 'パスワードを変更する',
            en: 'Change Password',
            en_html: '',
        },
        {
            key: '確認',
            ja: '確認',
            en: 'Confirmation',
            en_html: '',
        },
        {
            key: '未指定',
            ja: '未指定',
            en: 'unanswered',
            en_html: '',
        },
        {
            key: '未回答',
            ja: '未回答',
            en: 'unanswered',
            en_html: '',
        },
        {
            key: '支払い方法',
            ja: 'お支払い方法',
            en: 'Payment Method',
            en_html: '',
        },
        {
            key: '言語設定',
            ja: '言語設定',
            en: 'Language Settings',
            en_html: '',
        },
        {
            key: '検索表示許可',
            ja: '検索表示許可',
            en: 'Search Display',
            en_html: '',
        },
        {
            key: '更新する',
            ja: '更新する',
            en: 'UPDATE',
            en_html: '',
        },
        {
            key: '更新しました。',
            ja: '更新しました。',
            en: 'updated',
            en_html: '',
        },
        {
            key: '更新できませんでした。',
            ja: '更新できませんでした。',
            en: 'error occurred',
            en_html: '',
        },
        {
            key: '走行プログラム詳細',
            ja: '走行プログラム詳細',
            en: 'Program File',
            en_html: '',
        },
        {
            key: '走行スケジュール',
            ja: '走行スケジュール',
            en: 'Program Schedule',
            en_html: '',
        },
        {
            key: 'ご予約者',
            ja: 'ご予約者',
            en: 'Reservation',
            en_html: '',
        },
        {
            key: '走行ドライバー',
            ja: '走行ドライバー',
            en: 'Driver',
            en_html: '',
        },
        {
            key: '予約はありません。',
            ja: '予約はありません。',
            en: 'No Reservation',
            en_html: '',
        },
        {
            key: 'ゲスト会員',
            ja: 'ゲスト会員',
            en: 'Guest Member',
            en_html: '',
        },
        {
            key: 'ファイル',
            ja: 'ファイル',
            en: 'FILE',
            en_html: '',
        },

        {
            key: 'セダン',
            ja: 'セダン',
            en: 'Sedan',
            en_html: '',
        },

        {
            key: 'クーペ',
            ja: 'クーペ',
            en: 'Coupe',
            en_html: '',
        },

        {
            key: 'レーシングカー',
            ja: 'レーシングカー',
            en: 'Racing car',
            en_html: '',
        },
        {
            key: 'オープンカー',
            ja: 'オープンカー',
            en: 'Converible',
            en_html: '',
        },
        {
            key: 'SUV/ピックアップ',
            ja: 'SUV/ピックアップ',
            en: 'SUV/Pickup',
            en_html: '',
        },
        {
            key: 'ワゴン',
            ja: 'ワゴン',
            en: 'Wagon',
            en_html: '',
        },
        {
            key: 'ハイブリッド/EV',
            ja: 'ハイブリッド/EV',
            en: 'Hybrid/EV',
            en_html: '',
        },
        {
            key: 'ミニバン/ワンボックス',
            ja: 'ミニバン/ワンボックス',
            en: 'Minivan/One-box',
            en_html: '',
        },
        {
            key: 'コンパクトカー',
            ja: 'コンパクトカー',
            en: 'Compact car',
            en_html: '',
        },
        {
            key: '軽自動車',
            ja: '軽自動車',
            en: 'Light motor vehicle',
            en_html: '',
        },
        {
            key: 'キャンピングカー',
            ja: 'キャンピングカー',
            en: 'Camper-van',
            en_html: '',
        },
        {
            key: '軽トラック/軽バン',
            ja: '軽トラック/軽バン',
            en: 'Light truck/Van',
            en_html: '',
        },
        {
            key: 'トラック',
            ja: 'トラック',
            en: 'Truck',
            en_html: '',
        },
        {
            key: 'バス',
            ja: 'バス',
            en: 'Bus',
            en_html: '',
        },
        {
            key: '福祉車両',
            ja: '福祉車両',
            en: 'Assistive vehicle',
            en_html: '',
        },
        {
            key: '自走持込車',
            ja: '自走持込車',
            en: 'One\'s own car',
            en_html: '',
        },
        {
            key: 'オーナーズガレージ保管車',
            ja: 'ガレージ保管車',
            en: 'Garage-stored car',
            en_html: '',
        },
        {
            key: '請求書払',
            ja: '請求書払い',
            en: 'Payment by invoice',
            en_html: '',
        },
        {
            key: '銀行引き落とし',
            ja: '銀行引き落とし',
            en: 'Automatic bank transfer',
            en_html: '',
        },
        {
            key: 'クレジットカード事前登録による口座振替',
            ja: 'クレジットカード事前登録による口座振替',
            en: 'Automatic Credit Card Payment',
            en_html: '',
        },
	
        {
            key: '走行予約について',
            ja: '走行予約について',
            en: 'About Reservations',
            en_html: '',
        },
        {
            key: '宿泊・施設について',
            ja: '宿泊・施設について',
            en: 'Accommodations and Facilities',
            en_html: '',
        },
        {
            key: 'その他',
            ja: 'その他',
            en: 'Other',
            en_html: '',
        },
        {
            key: '日本語',
            ja: '日本語',
            en: 'Japanese',
            en_html: '',
        },
        {
            key: '英語',
            ja: '英語',
            en: 'English',
            en_html: '',
        },
        {
            key: '男性',
            ja: '男性',
            en: 'Male',
            en_html: '',
        },
        {
            key: '女性',
            ja: '女性',
            en: 'Female',
            en_html: '',
        },
        {
            key: 'A型',
            ja: 'A型',
            en: 'A',
            en_html: '',
        },
        {
            key: 'B型',
            ja: 'B型',
            en: 'B',
            en_html: '',
        },
        {
            key: 'AB型',
            ja: 'AB型',
            en: 'AB',
            en_html: '',
        },
        {
            key: 'O型',
            ja: 'O型',
            en: 'O',
            en_html: '',
        },
        {
            key:'初回講習',
            ja: '初回講習',
            en: 'First training session for members',
            en_html: '',
        },
        {
            key:'Guest初回講習',
            ja: 'Guest初回講習',
            en: 'First training session for guests',
            en_html: '',
        },
        {
            key:'Guest 座学',
            ja: 'Guest 座学',
            en: 'lecture for guests',
            en_html: '',
        },
        {
            key:'車両を走行後ガレージ保管される場合はその旨記載して下さい。',
            ja: '車両を走行後ガレージ保管される場合はその旨記載して下さい。',
            en: 'Garage storage after driving',
            en_html: '',
        },
        {
            key:'メンバーを追加登録する',
            ja: 'メンバーを追加登録する',
            en: 'additional entry',
            en_html: '',
        },
        {
            key:'走行枠合計金額',
            ja: '走行枠合計金額',
            en: 'Total Amount',
            en_html: '',
        },
        {
            key:'合計金額',
            ja: '合計金額',
            en: 'Total Amount',
            en_html: '',
        },
        {
            key:'残_',
            ja: '残',
            en: 'remain',
            en_html: '',
        },
        {
            key:'登録車両',
            ja: '登録車両',
            en: 'Registered Vehicles',
            en_html: '',
        },
        {
            key:'password required',
            ja: 'パスワードは必須です。',
            en: 'password required.',
            en_html: '',
        },
        {
            key:'passwords do not match',
            ja: 'パスワードが一致しません。',
            en: 'passwords do not match.',
            en_html: '',
        },
        {
            key:'mailaddress required',
            ja: 'ログインID(メールアドレス)は必須です。',
            en: 'mailaddress required.',
            en_html: '',
        },
        {
            key:'mailaddress do not match',
            ja: 'ログインID(メールアドレス)が一致しません。',
            en: 'mailaddress do not match.',
            en_html: '',
        },
        {
            key:'予約が完了しました。',
            ja: '予約が完了しました。',
            en: 'Reservation Completed',
            en_html: '',
        },
        {
            key:'予約できませんでした。',
            ja: '予約できませんでした。',
            en: 'error occurred.',
            en_html: '',
        },
        {
            key:'読み込み中',
            ja: '読み込み中',
            en: 'Now Loarding',
            en_html: '',
        },
        {
            key:'ログアウトmenu',
            ja: 'ログアウト',
            en: 'Logout',
            en_html: '',
        },
        {
            key:'チェックインS',
            ja: 'チェックイン',
            en: 'Check In',
            ja_html: '<label for="ReserveStay" style="font-size:1.5rem;">%%</label>',
            en_html: '<label for="ReserveStay" style="font-size:1.8rem;">%%</label>',
        },
        {
            key:'チェックアウトS',
            ja: 'チェックアウト',
            en: 'Check Out',
            ja_html: '<label for="ReserveStay" style="font-size:1.4rem;">%%</label>',
            en_html: '<label for="ReserveStay" style="font-size:1.8rem;">%%</label>',
        },
        {
            key:'キャンセルする',
            ja: 'キャンセルする',
            en: 'cancel',
            en_html: '',
        },
        {
            key:'キャンセルしました',
            ja: 'キャンセルしました',
            en: 'canceled',
            en_html: '',
        },
        {
            key:'キャンセルした予約を表示する',
            ja: 'キャンセルした予約を表示する',
            en: 'Show canceled reservations',
            en_html: '',
        },
        {
            key:'キャンセルした予約を表示させない',
            ja: 'キャンセルした予約を表示させない',
            en: 'Do not show cancelled reservations',
            en_html: '',
        },
        {
            key:'キャンセルご希望の場合はお問い合わせ下さい',
            ja: 'キャンセルご希望の場合はお問い合わせ下さい',
            en: 'If you wish to cancel, please contact us by phone or email.',
            en_html: '',
        },
        {
            key: '走行規約タイトル',
            ja: 'ドライビングコース走行規則',
            en: 'DRIVING COURSE RULES AND REGULATIONS',
            en_html: '',
        },
        {
            key: '走行料金カレンダー2406-08',
            ja: '6-8月料金カレンダー',
            en: 'Driving fees from June to August',
            en_html: '',
        },
        {
            key: '走行料金カレンダー2405',
            ja: '5月料金カレンダー',
            en: 'Fee Calendar/May',
            en_html: '',
        },
        {
            key: '走行料金カレンダー2406',
            ja: '6月料金カレンダー',
            en: 'Fee Calendar/June',
            en_html: '',
        },
        {
            key: '走行料金カレンダー2407',
            ja: '7月料金カレンダー',
            en: 'Fee Calendar/July',
            en_html: '',
        },
        {
            key: '走行料金カレンダー2408',
            ja: '8月料金カレンダー',
            en: 'Fee Calendar/August',
            en_html: '',
        },
        {
            key: '走行料金カレンダー2403-05',
            ja: '3-5月料金カレンダー',
            en: 'Driving fees effective starting in March',
            en_html: '',
        },
        {
            key: '走行料金カレンダー2401-02',
            ja: '1-2月料金カレンダー',
            en: 'Driving fees effective starting in January',
            en_html: '',
        },
        {
            key: 'アソシエイト会員規約',
            ja: 'アソシエイト会員権要項',
            en: 'THE MAGARIGAWA CLUB - Terms of Associate Membership',
            en_html: '',
        },
        {
            key: '正会員規約',
            ja: 'MAGARIGAWACLUB_会員規約',
            en: 'MAGARIGAWACLUB_Membership Rules',
            en_html: '',
        },
        {
            key: 'ドライビングプログラム',
            ja: 'DRIVE MASTER PROGRAM',
            en: 'DRIVE MASTER PROGRAM',
            en_html: '',
        },
    ]
});
